module.exports = __webpack_public_path__ + "static/media/Ronnie.07ef9331.jpg";